import React from "react";
import { connect } from "react-redux";
import { withRouter} from "react-router-dom";

import { withStyles } from "material-ui/styles";
import Icon from "material-ui/Icon";
import TextField from "material-ui/TextField";
import Button from "material-ui/Button";
import Grid from "material-ui/Grid";
import styles from "./styles";
import classnames from "classnames";
import Title from "../ui/title";
import Content from "../ui/content";
import Context from "./context/";
import { toast } from "react-toastify";

import Table from "../table";
import TestsRowLink from "../table/cells/testsRowLink";
import RowMove from "../table/cells/rowMove";
import Back from "../ui/back";

import Toolbar from "./toolbar/";

import JobHeader from "../common/jobs/jobHeader";
import NewTests from "./new";
import EditTests from "./edit";
import EditFiberTests from "./editfiber";
import RecertTests from "./recert";
import MoveTests from "./move";
import ReportGen from "./reportgen";
import CreateFiberTest from "./newfiber";
import ConfirmDialog from "../common/dialog/confirm";
import ListAttachments from "../common/jobandtestattachments/list";
import UploadAttachment from "../common/jobandtestattachments/add";
import TestSelection from "./testselection";

import MuiPickersUtilsProvider from "material-ui-pickers/utils/MuiPickersUtilsProvider";
import TimePicker from "material-ui-pickers/TimePicker";
import DatePicker from "material-ui-pickers/DatePicker";
import DateTimePicker from "material-ui-pickers/DateTimePicker";
import moment from "moment";
import MomentUtils from "material-ui-pickers/utils/moment-utils";
import Badge from "material-ui/Badge";

import SplitView from "../splitview";
import Treeview from "../treeview";

import {
  getISOTimeString,
  getISODateString,
  getISODateTimeString,
  vdvPicofaradsUnitConversion,
  metersToFeet,
  vdvMetersToFeet,
  timeFormatter,
  dateTimeFormatter,
  getFormattedNumber,
  getFormattedNumberWithPrecision,
  isVDVType,
  isCometType,
  isSignalTEK10GType,
  isSignalTEKQTType,
  isNaviTEKType
} from "../../common/utils";
import tr from "../subtestsetting/tr";
import {getPresetDefaultColumns} from "../../common/tabletools";
import { resetJobTreeview } from "../../redux/actions/jobActions";

moment.suppressDeprecationWarnings = true;

const jobDateTimeWithSecondsFormatter = pDate => {
  const _date = moment.utc(pDate).local();
  const locale = window.localStorage.language || "en-GB";
  return new Date(_date).toLocaleString(locale, {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit"
  });
};

class Job extends React.Component {
  constructor(props) {
    super(props);
    const { profile, nodeSelectedIds, modifiedJobId } = this.props;

    this.state = {
      modal: null,
      editTestsModal: null,
      editTestsModalError: null,
      recertTestModal: null,
      moveTestsModal: null,
      reportGenModal: null,
      deleteTestConfirm: false,
      contextMenu: false,
      tests: props.tests,
      treePath: props.location.state && props.location.state.path != undefined ? props.location.state.path :'',
      selectedTests: [],
      selected: {},
      selectAll: false,
      aggregateCols: [],
      expanded: null,
      test: null,
      lengthMeasurementUnit:
        profile && profile.units ? profile.units : "meters",
      jobAttachmentsModal: false,
      uploadModal: false,
      jobid: null,
      testid: null,
      filterable: false,
      filterdate: "",
      selectedDate: null,
      selectedTime: null,
      createdatDateTime: null,
      testSelected: {},
      fiberTestCreate: false,
      copperTestCreate: false,
      coaxTestCreate: false,
      editCoaxTestsModal: false,
      fiberTestEdit: false,
      isPreferenceUpdated: false,
      withAndWithoutResult: false,
      includeChildren: false,
      nodeId: '',
      testCountForTreeview: null,
      jobDeleted: false,
      treeviewJob: null,
    };
    this.toggle = this.toggle.bind(this);
    this.applyPreset = this.applyPreset.bind(this);
    this.toggleColumns = this.toggleColumns.bind(this);
    this.onSortedChange = this.onSortedChange.bind(this);
    this.onMoveTests = this.onMoveTests.bind(this);
    this.onMoveTestsClose = this.onMoveTestsClose.bind(this);
    this.showDeleteTestConfirm = this.showDeleteTestConfirm.bind(this);
    this.hideDeleteTestConfirm = this.hideDeleteTestConfirm.bind(this);
    this.onDeleteTest = this.onDeleteTest.bind(this);
  }

  componentDidUpdate(prevProps) {
    const { savePreferences, pager } = this.props;
    const { columns, isPreferenceUpdated } = this.state;
    if (columns && columns.length && !isPreferenceUpdated) {
      savePreferences(pager, columns, true);
      this.setState({ isPreferenceUpdated: true });
    }
  }

  activateSuspiciousFilter = e => {
    const { job, activateSuspiciousFilter, pager } = this.props;
    activateSuspiciousFilter(job.id, pager);
  };

  showAttachments = (e, jobid, testid) => {
    e.preventDefault();
    this.setState({
      jobid,
      testid,
      jobAttachmentsModal: true
    });
  };

  hideAttachments = e => {
    this.setState({
      jobid: null,
      testid: null,
      jobAttachmentsModal: false
    });
  };

  closeModal = reset => {
    const { getTests, pager } = this.props;
    const { jobid } = this.state;

    this.setState({
      jobid: null,
      testid: null,
      jobAttachmentsModal: false
    });
    getTests(pager, jobid);
  };

  showUplaodModal = () => {
    this.setState({
      uploadModal: true
    });
  };

  hideUplaodModal = () => {
    this.setState({
      uploadModal: false
    });
  };

  uploadFile = file => {
    const { jobid, testid } = this.state;
    const { uploadAttachment } = this.props;
    uploadAttachment(file, jobid, testid);
  };

  checkRecertify = () => {
    const { job } = this.props;
    const { selectedTests } = this.state;
    if (job && job.deviceid && selectedTests && selectedTests.length) {
      const hasLt4FiberTest = selectedTests.find(
        test => test.testtype === "39"
      );
      const hasLt4CoaxTest = selectedTests.find(test => test.testtype === "53");
      if (hasLt4FiberTest || hasLt4CoaxTest) {
        return false;
      } else {
        return true;
      }
    }
    return false;
  };

  checkShowEdit = (isMobileJob) => {
    const { selectedTests, withAndWithoutResult } = this.state;
    const { job } = this.props;
    let hasFiber = false;
    let hasCopper = false;
    let hasCoax = false;
    let withResult = 0;
    let withoutResult = 0;

    if (isMobileJob) {
      return (selectedTests && (selectedTests.length > 0));
    }

    if (selectedTests && selectedTests.length) {
      if (selectedTests.length > 1) {
        //If multiple
        if (job.deviceid) {
          selectedTests.forEach(x => {
            if (x.result_teststatus === null || x.result_teststatus === "") {
              withoutResult++;
            } else {
              withResult++;
            }
          });
        }
        selectedTests.forEach(test => {
          if (
            test.testtype === "39" ||
            (test.result_cabletype &&
              test.result_cabletype.toLowerCase() == "fiber")
          ) {
            hasFiber = true;
          } else if (
            test.testtype === "38" ||
            (test.result_cabletype &&
              test.result_cabletype.toLowerCase() == "twistedpaircable")
          ) {
            hasCopper = true;
          } else {
            hasCoax = true;
          }
        });
        //If multiple with and without result
        if (withoutResult > 0 && withResult > 0) {
          if (
            ((!hasCopper && hasFiber) || (hasCopper && !hasFiber)) &&
            !withAndWithoutResult
          ) {
            this.setState({ withAndWithoutResult: true });
          }
        } else if (withAndWithoutResult) {
          this.setState({ withAndWithoutResult: false });
        }
        //If multiple and has fiber and copper together, disable edit
        if (
          (hasCopper && hasFiber) ||
          (hasCopper && hasCoax) ||
          (hasCoax && hasFiber)
        ) {
          return false;
        }
      } else {
        if (withAndWithoutResult) {
          this.setState({ withAndWithoutResult: false });
        }
      }
      return true;
    }
    return false;
  };

  hasMixedIdentifiers = () => {
    const { selectedTests } = this.state;
    if (!selectedTests || selectedTests.length <= 1) {
      return false;
    }

    const getIdentifier = (test, level) => {
      const metadata = test.metadata && test.metadata.find(x => `${x.level}` === `${level}`);
      return {
        field:
          test[`level${level}key`] ||
          test[`level${level}Key`] ||
          test[`Level${level}Key`] ||
          (metadata && metadata.field) ||
          "",
        value:
          test[`level${level}value`] ||
          test[`level${level}Value`] ||
          test[`Level${level}Value`] ||
          (metadata && metadata.value) ||
          ""
      };
    };

    const first = selectedTests[0];
    return selectedTests.some(
      test => [1, 2, 3, 4, 5, 6].some(level => {
        const current = getIdentifier(test, level);
        const expected = getIdentifier(first, level);
        return current.field !== expected.field || current.value !== expected.value;
      })
    );
  };

  saveTest = (test, pager) => {
    this.setState({ selected: {}, selectedTests: [] });
    this.props.saveNewTests(test, pager);
    let preferenceModel = {
      metadata: test.metadata
    };
    this.props.postUserPreference(false, preferenceModel);
  };

  resetTestCounter = () => {
    this.setState({ selected: {}, selectedTests: [] });
  };

  saveFibertest = (test, pager) => {
    this.setState({ selected: {}, selectedTests: [] });
    this.props.saveFiberNewTests(test, pager);
    let preferenceModel = {
      metadata: test.metadata
    };
    this.props.postUserPreference(false, preferenceModel);
  };

  testSelection = (fiber, copper, coax) => {
    if (copper) {
      this.setState({
        copperTestCreate: true,
        coaxTestCreate: false,
        modal: false
      });
    } else if (fiber) {
      this.setState({
        fiberTestCreate: true,
        modal: false
      });
    } else if (coax) {
      this.setState({
        coaxTestCreate: true,
        copperTestCreate: false,
        modal: false
      });
    }
  };

  render() {
    const {
      classes,
      translate,
      job,
      jobs,
      standards,
      fiberStandards,
      custom,
      languages,
      saveNewTests,
      saveFiberNewTests,
      testsCreated,
      errors,
      pager,
      fetch,
      copperModalState,
      fiberModalState,
      savePreferences,
      applyPreset,
      columnPreset,
      preferences,
      preferencesSaved,
      customers,
      customer,
      getCustomer,
      attachments,
      getAttachments,
      deleteAttachment,
      attachmentDownload,
      filteredJobs,
      getJobs,
      refresh,
      selectedCustomerName,
      selectedCustomerId,
      clearAttachments,
      resetForm,
      fibertest,
      selectedLanguage,
      saveSelectedRow,
      previousRow,
      testNames,
      userPreference,
      uploadTestIDFile,
      testNameList,
      IDerrors,
      clearDuplicateError,
      clearImportDuplicateError,
      countryStates,
      nodeSelectedIds,
      modifiedJobId,
      fileUploadSettings,
      impersonating,
      checkSmartFlags,
      resetSmartFlags,
      showSmartFlagProfileContext,
      onEditSmartFlagProfile,
      onSmartFlagProfileChange,
      smartFlagProfiles,
      openJobEditForSmartFlags
    } = this.props;
    const {
      modal,
      editTestsModal,
      editTestsModalError,
      recertTestModal,
      moveTestsModal,
      reportGenModal,
      tests,
      test,
      selectAll,
      selectedTests,
      selected,
      aggregateCols,
      filterable,
      testSelected,
      lengthMeasurementUnit,
      withAndWithoutResult,
      jobDeleted,
      treeviewJob
    } = this.state;

    // filter the tests by the path from the treeview
    // if the path is | delimited it is a click from the treeview, otherwise a navigation from a job click
    if (tests){
      var totalPages = document.getElementById('total-pages');

      if (totalPages && pager.pageno > Number(totalPages.innerHTML)) {
        pager.pageIndex = 0;
        pager.pageno = 1;
      }

      var path = this.state.treePath.split('|');
      var pathLength = path.length;

      var pathToCheckAgainst = path.slice(3, pathLength -1);

      const checkLevel = (pathItem, test) => {

        var id6 = test[`level6id`];
        var id5 = test[`level5id`];
        var id4 = test[`level4id`];
        var id3 = test[`level3id`];
        var id2 = test[`level2id`];

        if (nodeSelectedIds.includes(id6) || nodeSelectedIds.includes(id5) || nodeSelectedIds.includes(id4) || nodeSelectedIds.includes(id3) || nodeSelectedIds.includes(id2)) {
          return true;
        }

        return false;
      };

      var filteredTests = tests.data ? tests.data.filter(testItem => {
        return pathToCheckAgainst.every((item) => {
          if (nodeSelectedIds === null || nodeSelectedIds === '') {
            return true;
          }
          return checkLevel(item, testItem )
        })
      }) : undefined;
    }

    const isMobileJob = job.deviceid && isVDVType(job.deviceid);
    const createEnabled = job.deviceid && !isMobileJob ? true : false;
    let $modal = null;
    if (modal) {
      $modal = (
        <TestSelection
          translate={translate}
          testSelection={(fiber, copper, coax) =>
            this.testSelection(fiber, copper, coax)
          }
          cancel={(cancel, modelType) => this.add(cancel, modelType)}
        />
      );
    }

    let $fiberTestModal = null;
    if (this.state.fiberTestCreate) {
      $fiberTestModal = (
        <CreateFiberTest
          job={job}
          standards={standards}
          fiberStandards={fiberStandards}
          custom={custom}
          saveNewTests={this.saveFibertest}
          translate={translate}
          cancel={cancel => this.add(cancel, "fibertestModal")}
          testsCreated={testsCreated}
          error={errors}
          pager={pager}
          modalState={fiberModalState}
          selectedCustomerId={selectedCustomerId}
          lengthMeasurementUnit={lengthMeasurementUnit}
          userPreference={userPreference}
          uploadTestIDFile={uploadTestIDFile}
          testNameList={testNameList}
          IDerrors={IDerrors}
          clearDuplicateError={clearDuplicateError}
          clearImportDuplicateError={clearImportDuplicateError}
        />
      );
    }
    let $editFiberTestModal = null;
    if (this.state.fiberTestEdit) {
      $editFiberTestModal = (
        <EditFiberTests
          job={job}
          standards={standards}
          custom={custom}
          fiberStandards={fiberStandards}
          multiple={selectedTests && selectedTests.length > 1 ? true : false}
          saveEditTest={this.onSaveEditTest.bind(this)}
          translate={translate}
          cancel={() => this.closeEdit()}
          testsCreated={testsCreated}
          pager={pager}
          modalState={fiberModalState}
          error={editTestsModalError}
          resetForm={resetForm}
          selectedCustomerId={selectedCustomerId}
          test={fibertest}
          otherTest={test}
          lengthMeasurementUnit={lengthMeasurementUnit}
          selectedTests={selectedTests}
          withAndWithoutResult={withAndWithoutResult}
          testNames={testNames}
          userPreference={userPreference}
          mixedIdentifiers={this.hasMixedIdentifiers()}
        />
      );
    }
    let $coppertestModal = null;
    if (this.state.copperTestCreate) {
      $coppertestModal = (
        <NewTests
          job={job}
          standards={standards}
          custom={custom}
          saveNewTests={this.saveTest}
          translate={translate}
          cancel={cancel => this.add(cancel, "coppertestModal")}
          testsCreated={testsCreated}
          error={errors}
          pager={pager}
          modalState={copperModalState}
          selectedCustomerId={selectedCustomerId}
          userPreference={userPreference}
          isCopperTest={this.state.copperTestCreate}
          uploadTestIDFile={uploadTestIDFile}
          testNameList={testNameList}
          IDerrors={IDerrors}
          clearDuplicateError={clearDuplicateError}
          clearImportDuplicateError={clearImportDuplicateError}
        />
      );
    }
    let $editTestsModal = null;
    if (editTestsModal) {
      $editTestsModal = (
        <EditTests
          job={job}
          standards={standards}
          custom={custom}
          multiple={selectedTests && selectedTests.length > 1 ? true : false}
          saveEditTest={this.onSaveEditTest.bind(this)}
          translate={translate}
          cancel={() => this.closeEdit()}
          testsCreated={testsCreated}
          pager={pager}
          modalState={copperModalState}
          test={test}
          error={editTestsModalError}
          resetForm={resetForm}
          selectedCustomerId={selectedCustomerId}
          selectedTests={selectedTests}
          withAndWithoutResult={withAndWithoutResult}
          testNames={testNames}
          isCopperTest={this.state.editTestsModal}
          impersonating={impersonating}
          mixedIdentifiers={this.hasMixedIdentifiers()}
        />
      );
    }
    //COAX
    let $coaxTestModal = null;
    if (this.state.coaxTestCreate) {
      $coaxTestModal = (
        <NewTests
          job={job}
          standards={standards}
          custom={custom}
          saveNewTests={this.saveTest}
          translate={translate}
          cancel={cancel => this.add(cancel, "coaxtestModal")}
          testsCreated={testsCreated}
          error={errors}
          pager={pager}
          modalState={copperModalState}
          selectedCustomerId={selectedCustomerId}
          isCopperTest={this.state.copperTestCreate}
          userPreference={userPreference}
          uploadTestIDFile={uploadTestIDFile}
          testNameList={testNameList}
          IDerrors={IDerrors}
          clearDuplicateError={clearDuplicateError}
          clearImportDuplicateError={clearImportDuplicateError}
        />
      );
    }
    let $editCoaxTestModal = null;
    if (this.state.editCoaxTestsModal) {
      $editCoaxTestModal = (
        <EditTests
          job={job}
          standards={standards}
          custom={custom}
          multiple={selectedTests && selectedTests.length > 1 ? true : false}
          saveEditTest={this.onSaveEditTest.bind(this)}
          translate={translate}
          cancel={() => this.closeEdit()}
          testsCreated={testsCreated}
          pager={pager}
          modalState={copperModalState}
          test={test}
          error={editTestsModalError}
          resetForm={resetForm}
          selectedCustomerId={selectedCustomerId}
          selectedTests={selectedTests}
          withAndWithoutResult={withAndWithoutResult}
          testNames={testNames}
          isCopperTest={!this.state.editCoaxTestsModal}
          impersonating={impersonating}
          mixedIdentifiers={this.hasMixedIdentifiers()}
        />
      );
    }

    let $recertTestModal = null;
    if (recertTestModal) {
      $recertTestModal = (
        <RecertTests
          job={job}
          standards={standards}
          saveRecertTest={this.onSaveRecertTest.bind(this)}
          translate={translate}
          cancel={() => this.closeRecert()}
          testsCreated={testsCreated}
          pager={pager}
          selectedTests={selectedTests}
        />
      );
    }

    let $moveTestsModal = null;
    if (moveTestsModal) {
      $moveTestsModal = (
        <MoveTests
          translate={translate}
          selectedTests={selectedTests}
          job={job}
          jobs={jobs}
          selectedtotal={selectedTests && selectedTests.length}
          selectAll={selectAll}
          onClose={this.onMoveTestsClose}
          onSubmit={this.onMoveTests}
          filteredJobs={filteredJobs}
          getJobs={getJobs}
        />
      );
    }

    let $reportGenModal = null;
    if (reportGenModal) {
      $reportGenModal = (
        <ReportGen
          job={this.state.treeviewJob ? this.state.treeviewJob : job}
          language={selectedLanguage}
          translate={translate}
          languages={languages}
          customers={customers}
          customer={customer}
          getCustomer={getCustomer}
          selectedTests={selectedTests}
          selectedtotal={(this.state.nodeId == null || this.state.nodeId.length <= 0)  ? selectedTests && selectedTests.length : this.state.testCountForTreeview}
          selectAll={selectAll}
          cancel={() => this.hideReportGen()}
          submit={ data => this.generateReport(data) }
          countryStates={ countryStates}
        />
      );
    }
    let $deleteTestConfirm = (
      <ConfirmDialog
        open={this.state.deleteTestConfirm}
        title={translate("tests_delete_confirm_title")}
        contentText={translate("tests_delete_confirm_text", {
          number: selectedTests && selectedTests.length
        })}
        contentSecondaryText={translate("general_confirmation_help_2")}
        okText={translate("general_confirm")}
        cancelText={translate("general_cancel")}
        onOk={this.onDeleteTest}
        onCancel={this.hideDeleteTestConfirm}
      />
    );
    let $context = (
      <Context
        job={job}
        toggleColumns={this.toggleColumns}
        applyPreset={this.applyPreset}
        columnPreset={columnPreset}
        data={tests ? tests.data : []}
        columns={
          preferences && preferences.columns
            ? preferences.columns
            : this.state.columns
        }
        translate={translate}
        isSignaltek10g={false}
        isMobile={isMobileJob}
      />
    );

    let $jobAttachmentsModal = this.state.jobAttachmentsModal ? (
      <ListAttachments
        translate={translate}
        close={this.closeModal}
        jobid={this.state.jobid}
        testid={this.state.testid}
        attachments={attachments}
        getAttachments={getAttachments}
        hideUplaodModal={this.hideUplaodModal}
        showUplaodModal={this.showUplaodModal}
        deleteAttachment={deleteAttachment}
        attachmentDownload={attachmentDownload}
        clearAttachments={clearAttachments}
      />
    ) : null;

    let $fileUploadModal = this.state.uploadModal ? (
      <UploadAttachment
        translate={translate}
        jobid={this.state.jobid}
        testid={this.state.testid}
        hideUplaodModal={this.hideUplaodModal}
        uploadFile={this.uploadFile}
        fileUploadSettings={fileUploadSettings}
      />
    ) : null;

    if (filteredTests){
      tests.data = filteredTests;
    }

    let expanded = {};
    let data = [];
    if (aggregateCols.length && tests && tests.data && tests.data.length) {
      let hash = {},
        grouped = [],
        groups = [];
      tests.data.forEach(function(o) {
        let key = [
          "level2value",
          "level3value",
          "level4value",
          "level5value",
          "level6value",
          "level2key",
          "level3key",
          "level4key",
          "level5key",
          "level6key"
        ]
          .map(k => {
            return o[k];
          })
          .join("|");

        if (!hash[key]) {
          hash[key] = { key };
          let obj = {};
          let str = "";
          let levels = [6, 5, 4, 3, 2];
          let nbsp = String.fromCharCode(160);
          levels.map(idx => {
            // if (o[`level${idx}value`]) {
            // obj[o[`level${idx}value`]] = o[`level${idx}key`]
            obj[`level${idx}value`] = o[`level${idx}value`];
            obj[`level${idx}key`] = o[`level${idx}key`];
            if (o[`level${idx}key`]) {
              str +=
                o[`level${idx}key`] +
                ":" +
                nbsp +
                o[`level${idx}value`] +
                nbsp +
                nbsp +
                nbsp;
            }
            return idx;
          });
          groups.push({
            group: true,
            filter: obj,
            str
          });
          grouped.push(hash[key]);
        }
      });
      groups.map(group => {
        let filtered = tests.data.filter(obj => {
          for (var key in group.filter) {
            if (obj[key] === undefined || obj[key] !== group.filter[key]) {
              return false;
            }
          }
          return true;
        });
        data.push(group, ...filtered);
        return group;
      });

      grouped.map((d, k) => {
        expanded[k] = {};
        return d;
      });
    }

    const tableSortProps =
      pager && pager.sort
        ? {
            sorted: pager && pager.sort ? pager.sort : []
          }
        : null;

    const tableFilterProps =
      pager && pager.filter
        ? {
            filtered: pager && pager.filter ? pager.filter : undefined
          }
        : null;

    const tablePageProps =
      pager && pager.pageIndex !== undefined
        ? {
            page:
              pager && pager.pageIndex !== undefined
                ? pager.pageIndex
                : undefined
          }
        : null;

    let all =
      Object.keys(this.state.selected).length &&
      Object.keys(this.state.selected)
        .map(c => this.state.selected[c])
        .every(x => x);

    let isShowEdit = this.checkShowEdit(isMobileJob);
    let isRecertify = !isMobileJob && this.checkRecertify();

    return (
        <div className={classes.divContent}>
          <Title
            title={job.name}
            custTitle={
              selectedCustomerName && (
                <Back
                  title={translate("general_customers")}
                  link={"/customers"}
                />
              )
            }
            custName={
              selectedCustomerName && (
                <Back
                  title={selectedCustomerName}
                  link={`/customers/${selectedCustomerId}`}
                />
              )
            }
            back={
              <Back
                link={
                  selectedCustomerId ? `/jobs/${selectedCustomerId}` : "/jobs"
                }
                title={translate("general_jobs")}
              />
            }
            toolbar={
              <Toolbar
                translate={translate}
                toggle={() => this.toggle()}
                createEnabled={createEnabled}
                add={() => this.add(null, "testSelection")}
                showEdit={isShowEdit}
                job={job}
                showMove={
                  (selectedTests && selectedTests.length) || all ? true : false
                }
                showDelete={
                  (selectedTests && selectedTests.length) || all ? true : false
                }
                showRecert={isRecertify}
                showReportGen={
                  (selectedTests && selectedTests.length) || all ? true : false
                }
                move={() => this.move()}
                edit={() => this.edit()}
                recert={() => this.recert()}
                del={this.showDeleteTestConfirm}
                reportGen={() => this.showReportGen()}
                toggleFilters={this.toggleFilters}
                refresh={refresh}
                checkSmartFlags={checkSmartFlags}
                resetSmartFlags={resetSmartFlags}
                openJobEditForSmartFlags={openJobEditForSmartFlags}
              />
            }
          />
          <SplitView show={true} left={<Treeview jobDeleted={jobDeleted} jobs={jobs} job={job} resetTestCount={this.resetTestCounter} refreshTest={refresh} translate={translate} showReportModal={this.showReportFromTreeview} showAddJob={false}></Treeview>}>
            <Content
              ctx={$context}
              open={this.state.contextMenu}
              toggle={() => this.toggle()}
              translate={translate}
            >
              <JobHeader
                job={job}
                translate={translate}
                totalSelected={selectedTests.length}
                isSelectionShow={true}
                showSmartFlagProfileContext={showSmartFlagProfileContext}
                onEditSmartFlagProfile={onEditSmartFlagProfile}
                onSmartFlagProfileChange={onSmartFlagProfileChange}
                smartFlagProfiles={smartFlagProfiles}
              />
              {tests ? (
                <Table
                  translate={translate}
                  filterable={filterable}
                  pages={tests ? tests.pagecount : 0}
                  manual={pager.manual}
                  defaultPageSize={pager.pagesize}
                  data={tests ? data : []}
                  columns={this.state.columns}
                  fetch={fetch}
                  onSortedChange={this.onSortedChange}
                  allowSelect
                  allowDnd={true}
                  selectedRows={this.selectedRows}
                  selected={selected}
                  testSelected={testSelected}
                  selectAll={selectAll}
                  selectedTests={selectedTests}
                  saveSelectedRow={saveSelectedRow}
                  previousRow={previousRow}
                  isShiftSelectPage={true}
                  className={"testsTable"}
                  wrapHeaders
                  expanded={Array.from(
                    Array(data.length),
                    (val, index) => index + 1
                  )}
                  expanderDefaults={{ show: false }}
                  style={{
                    border: "none",
                    marginTop: "50px"
                  }}
                  noDataText={createEnabled ? "no_test_data" : "no_lt3_test_data"}
                  minRows={tests.data && tests.data.length ? 0 : undefined}
                  getTrProps={(state, rowInfo, column) => {
                    if (rowInfo && rowInfo.original && rowInfo.original.group) {
                      return {
                        style: {
                          height: "0px",
                          display: "none"
                        }
                      };
                    }
                    return {};
                  }}
                  SubComponent={row => {
                    if (!row.original.group) {
                      return;
                    }
                    let content = row.original.str;
                    // Object.keys(row.original).map((k, idx) => {
                    //   if (k && k !== 'group') {
                    //     content += `${k}: ${row.original[k]}     `
                    //   }
                    // })
                    // if (content === '') content = ''
                    let groupSize = 12;
                    let filterSize = 0;
                    if (!row.index) {
                      groupSize = 10;
                      filterSize = 2;
                    }
                    return (
                      <Grid container spacing={0}>
                        <Grid
                          item
                          xs={groupSize}
                          style={{
                            height: "40px",
                            backgroundColor: "#1F2532",
                            color: "white",
                            padding: "5px 5px 5px 20px",
                            lineHeight: "34px"
                          }}
                        >
                          {content}
                        </Grid>
                        {!row.index && (
                          <Grid
                            item
                            xs={filterSize}
                            style={{
                              height: "40px",
                              backgroundColor: "#1F2532",
                              color: "white",
                              padding: "0px"
                            }}
                          >
                            {/* <Button
                              variant="outlined"
                              className={classnames(
                                classes.button,
                                classes.suspiciousfilter,
                                job.suspicious
                                  ? classes.suspiciousfilteractivated
                                  : classes.suspiciousfilternotrun
                              )}
                              onClick={this.activateSuspiciousFilter}
                            >
                              {translate("suspicious_filter")}
                              <Icon>{job.suspicious ? "sync" : "play_arrow"}</Icon>
                            </Button> */}
                          </Grid>
                        )}
                      </Grid>
                    );
                  }}
                  applyPreset={applyPreset}
                  savePreferences={savePreferences}
                  preferences={preferences}
                  preferencesSaved={preferencesSaved}
                  pager={pager}
                  {...tableFilterProps}
                  {...tableSortProps}
                  {...tablePageProps}
                />
              ) : null}
              {$modal}
              {$editTestsModal}
              {$moveTestsModal}
              {$deleteTestConfirm}
              {$recertTestModal}
              {$reportGenModal}
              {$jobAttachmentsModal}
              {$fileUploadModal}
              {$coppertestModal}
              {$fiberTestModal}
              {$editFiberTestModal}
              {$coaxTestModal}
              {$editCoaxTestModal}
            </Content>
          </SplitView>
        </div>
    );
  }

  add = async (isCancel, modelType) => {
    if (!this.props.standards) {
      await this.props.getStandards();
    }
    if (!this.props.fiberStandards) {
      await this.props.getFiberStandards();
    }
    if (isCancel === "cancel") {
      this.props.clearDuplicateError();
      this.props.clearImportDuplicateError();
    }
    if (!this.props.custom) {
      this.props.getCustom();
    }
    if (isCancel === "cancel" && modelType === "testSelection") {
      this.setState({
        modal: false
      });
    } else if (modelType === "testSelection") {
      this.setState({
        modal: true
      });
    }
    if (isCancel === "cancel" && modelType === "coppertestModal") {
      this.setState({
        copperTestCreate: false
      });
    }
    if (isCancel === "cancel" && modelType === "fibertestModal") {
      this.setState({
        fiberTestCreate: false
      });
    }
    if (isCancel === "cancel" && modelType === "coaxtestModal") {
      this.setState({
        coaxTestCreate: false
      });
    }
    if (isCancel != "cancel") {
      this.props.getUserPreference();
    }
  };

  edit = async () => {
    const { job } = this.props;
    if (!this.props.standards) {
      await this.props.getStandards();
    }
    if (!this.props.fiberStandards) {
      await this.props.getFiberStandards();
    }

    if (!this.props.custom) {
      this.props.getCustom();
    }
    if (job.deviceid) {
      if (
        this.state.selectedTests.length &&
        this.state.selectedTests[0].testtype === "39"
      ) {
        this.setState({
          fiberTestEdit: true
        });
        if (this.state.selectAll) {
          this.props.getFiberTest(this.state.tests.data[0].id);
        } else {
          this.props.getFiberTest(this.state.selectedTests[0].id);
        }
      } else if (
        this.state.selectedTests.length &&
        this.state.selectedTests[0].testtype === "38"
      ) {
        this.setState({
          editTestsModal: true
        });
      } else
        this.setState({
          editCoaxTestsModal: true
        });
    } else {
      this.setState({
        editTestsModal: true
      });
    }
    if (this.state.selectAll) {
      this.props.getTest(this.state.tests.data[0].id);
    } else {
      this.props.getTest(this.state.selectedTests[0].id);
    }
  };

  recert() {
    if (!this.props.standards) {
      this.props.getStandards();
    }
    this.setState({
      recertTestModal: true
    });
  }
  onSaveRecertTest(test, pager) {
    let self = this;
    let selectedTests = [...self.state.selectedTests];
    if (selectedTests.length > 0) {
      test.testids = selectedTests.map(ele => ele.id);
    }
    this.props
      .saveRecertTest(test, pager)
      .then(resp => {
        this.setState({
          recertTestModal: false,
          selectedTests: [],
          selected: {},
          selectAll: false
        });
      })
      .catch(err => {
        this.setState({
          recertTestModal: true
        });
      });
  }
  closeRecert() {
    this.setState({
      recertTestModal: false
    });
  }
  onSaveEditTest(test, pager, fiber) {
    let self = this;
    let selectedTests = [...self.state.selectedTests];
    if (selectedTests.length > 1) {
      test.testids = selectedTests.map(ele => ele.id);
    }

    if (fiber === "fiber") {
      return this.props
        .saveFiberEditTest(test, pager)
        .then(resp => {
          this.props.setSelectedTests(null);
          self.setState({
            fiberTestEdit: false,
            editTestsModalError: null,
            selectedTests: [],
            selected: {},
            selectAll: false
          });
        })
        .catch(err => {
          self.setState({
            editTestsModalError: err
          });
        });
    } else {
      return this.props
        .saveEditTest(test, pager)
        .then(resp => {
          this.props.setSelectedTests(null);
          self.setState({
            editTestsModal: false,
            editCoaxTestsModal: false,
            editTestsModalError: null,
            selectedTests: [],
            selected: {},
            selectAll: false
          });
        })
        .catch(err => {
          self.setState({
            editTestsModalError: err
          });
        });
    }
  }

  closeEdit() {
    this.setState({
      editTestsModal: false,
      editCoaxTestsModal: false,
      editTestsModalError: null,
      fiberTestEdit: false
    });
  }

  move() {
    this.setState({
      moveTestsModal: true
    });
  }
  onMoveTests(data) {
    const { pager } = this.props;
    const { selectAll, tests } = this.state;
    if (selectAll || data.testids.length === tests.data.length) {
      if (pager.pageIndex > 0) {
        pager.pageIndex -= 1;
      }
      if (pager.pageno > 1) {
        pager.pageno -= 1;
      }
    }
    this.props.moveTests(data, pager).then(response => {
      this.setState({
        selectedTests: [],
        selected: {},
        selectAll: false
      });
    });
    this.setState({
      moveTestsModal: null
    });
  }
  onMoveTestsClose() {
    this.setState({
      moveTestsModal: false
    });
  }
  showDeleteTestConfirm() {
    this.setState({
      deleteTestConfirm: true
    });
  }
  hideDeleteTestConfirm() {
    this.setState({
      deleteTestConfirm: false
    });
  }
  onDeleteTest() {
    const { pager, job } = this.props;
    const { selectedTests, selectAll, tests } = this.state;
    let data;
    data = {
      testids: selectedTests.map((item, index) => item.id),
      jobid: job.id
    };

    if (selectAll || data.testids.length === tests.data.length) {
      pager.pageIndex = 0;
      pager.pageno = 1;
    }

    this.props.deleteTests(data, pager).then(response => {
      this.setState({
        selectedTests: [],
        selected: {},
        selectAll: false,
        jobDeleted: true
      });
    });
    this.setState({
      deleteTestConfirm: false
    });
  }

  showReportGen() {
    const { selectedTests } = this.state;
    const testids = selectedTests.map(test => test.id);
    this.state.nodeId = "";
    this.props
      .checkForReport({ testids, selectall: false, jobid: "" })
      .then(response => {
        if (response.testnames.length === 0) {
          this.props.getCustomers({
            pageno: 0,
            pagesize: 0
          });
          this.setState({
            reportGenModal: true
          });
        } else {
          let testNames = null;
          if (response.testnames.length > 10) {
            testNames = response.testnames.slice(0, 10).join(" ");
          } else {
            testNames = response.testnames.join(" ");
          }
          let resultCabletype = selectedTests.filter(
            x => x.result_cabletype !== null
          );
          if (resultCabletype.length !== selectedTests.length) {
            toast.info(` ${this.props.translate("report_generate_empty")}`, {
              position: toast.POSITION.TOP_CENTER,
              hideProgressBar: true
            });
          } else {
            toast.info(
              ` ${this.props.translate("report_generate_help")} ${testNames}`,
              {
                position: toast.POSITION.TOP_CENTER,
                hideProgressBar: true
              }
            );
          }
        }
      });
  }

  showReportFromTreeview = (job) => {
    const { selectedTests } = this.state;
    const testids = selectedTests.map(test => test.id);

    this.setState({
      includeChildren: job.includeLowerRecords,
      nodeId: job.nodeId,
      treeviewJob: job,
      nodeTestCount: job.nodeTestCount
    });

    this.props
      .checkForReportForTreeview({ jobId: job.id, nodeId: job.nodeId, includeChildren: job.includeLowerRecords })
      .then(response => {
        this.setState({
          testCountForTreeview: job.nodeTestCount
        });
        if (response.testnames.length === 0) {
          this.props.getCustomers({
            pageno: 0,
            pagesize: 0
          });
          this.setState({
            reportGenModal: true
          });
        } else {
          let testNames = null;
          if (response.testnames.length > 10) {
            testNames = response.testnames.slice(0, 10).join(" ");
          } else {
            testNames = response.testnames.join(" ");
          }
          let resultCabletype = selectedTests.filter(
            x => x.result_cabletype !== null
          );
          if (resultCabletype.length !== selectedTests.length) {
            toast.info(` ${this.props.translate("report_generate_empty")}`, {
              position: toast.POSITION.TOP_CENTER,
              hideProgressBar: true
            });
          } else {
            toast.info(
              ` ${this.props.translate("report_generate_help")} ${testNames}`,
              {
                position: toast.POSITION.TOP_CENTER,
                hideProgressBar: true
              }
            );
          }
        }
      });
  }

  hideReportGen() {
    this.setState({
      reportGenModal: false
    });
  }

  generateReport = data => {
    const { job, lantekreportcount, cometreportcount } = this.props;
    const { selectedTests, nodeId, includeChildren, testCountForTreeview } = this.state;

    data.nodeId = nodeId;
    data.includeChildren = includeChildren;

    if (
      job &&
      job.deviceid &&
      job.deviceid.toLowerCase() === "comet_copper" &&
      data.type &&
      data.type.toLowerCase() !== "singleline" &&
      selectedTests.length > cometreportcount
    ) {
      toast.error(
        this.props.translate("brief_report_too_many_tests", {
          value: cometreportcount
        }),
        {
          position: toast.POSITION.TOP_CENTER,
          hideProgressBar: true
        }
      );
      return;
    }
    if (
      job &&
      !job.deviceid &&
      data.type &&
      data.type.toLowerCase() !== "singleline" &&
      selectedTests.length > lantekreportcount
    ) {
      toast.error(
        this.props.translate("brief_report_too_many_tests", {
          value: lantekreportcount
        }),
        {
          position: toast.POSITION.TOP_CENTER,
          hideProgressBar: true
        }
      );
      return;
    }
    this.props.generateReport(data);
    this.hideReportGen();
    this.setState({
      selectedTests: [],
      selected: {},
      selectAll: false
    });
  };

  componentDidMount() {
    this.props.saveSelectedRow(null);
  }

  componentWillReceiveProps(nextProps) {
    const { pager, job, profile, columnPresets } = nextProps;

    let jobType = this.getJobType(job);
    const defaultColumns = columnPresets.hasOwnProperty(jobType)
      ? columnPresets[jobType]
      : getPresetDefaultColumns(jobType);

    if (this.props.pager.defaultColumns !== defaultColumns) {
      this.props.pager.defaultColumns = defaultColumns;
    }
    const { tests, test } = nextProps;
    if (nextProps.testsCreated) {
      this.setState({
        modal: false,
        copperTestCreate: false,
        fiberTestCreate: false,
        coaxTestCreate: false
      });
    }
    if (pager.pageno !== this.props.pager.pageno) {
      this.setState({
        selectedTests: []
      });
    }
    if (tests) {
      this.setState({
        tests
      });
    }

    this.setState({
      test
    });

    const nextLengthMeasurementUnit = profile && profile.units
      ? profile.units
      : this.state.lengthMeasurementUnit;

    if (profile) {
      this.setState({
        lengthMeasurementUnit: nextLengthMeasurementUnit
      });
    }

    //  if (this.state.tests !== nextProps.tests) {
    //     this.setState({
    //       selected: {},
    //       selectedTests: []
    //     })
    //   }

    //  if (this.state.tests && tests && tests.data && this.state.tests.data.length !== tests.data.length && this.state.selectAll) {
    //   this.setState({
    //     selected: {},
    //     selectedTests: []
    //   })
    // }
    this.setColumns(
      tests,
      defaultColumns,
      job,
      nextProps.preferences,
      nextProps.smartFlagChecksDone,
      nextProps.smartFlagChecks,
      nextProps.smartFlagEvaluatedTestIds,
      nextLengthMeasurementUnit
    );
  }

  getJobType = (job) => {
    if (job) {
      if (isVDVType(job.deviceid)) {
        return "VDVII_PoEPro";
      } else if (isCometType(job.deviceid)) {
        return "LanTEKIV";
      } else if (isSignalTEKQTType(job.deviceid)) {
        return "SignalTEKQT";
      } else if (isNaviTEKType(job.deviceid)) {
        return "NaviTEKIII";
      } else if (isSignalTEK10GType(job.deviceid)) {
        return "SignalTEK10G";
      }
    }
    return "LanTEKIII";
  };

  componentWillMount() {
    const { pager, setSelectedTests, job, selectColumnPreset, columnPresets, smartFlagChecksDone } = this.props;
    const { tests } = this.state;
    if (pager.filter && pager.filter.length > 0) {
      this.setState({ filterable: true });
    }

    let jobType = this.getJobType(job);
    const defaultColumns = columnPresets && columnPresets.hasOwnProperty(jobType)
      ? columnPresets[jobType]
      : getPresetDefaultColumns(jobType);

    this.setColumns(
      tests,
      defaultColumns,
      job,
      null,
      smartFlagChecksDone,
      this.props.smartFlagChecks,
      this.props.smartFlagEvaluatedTestIds
    );
    setSelectedTests(null);

    selectColumnPreset(jobType);
    this.props.resetJobTreeview(this.props);
  }

  setColumns(
    tests,
    defaultColumns,
    job,
    preferences,
    smartFlagChecksDone,
    smartFlagChecks = this.props.smartFlagChecks,
    smartFlagEvaluatedTestIds = this.props.smartFlagEvaluatedTestIds,
    lengthMeasurementUnitOverride = null
  ) {
    const { translate, classes, showSmartFlags } = this.props;

    let {
      lengthMeasurementUnit,
      filterable,
      filterdate,
      selectedTime,
      selectedDate,
      createdatDateTime
    } = this.state;
    lengthMeasurementUnit = lengthMeasurementUnitOverride || lengthMeasurementUnit;
    let columns = [];

    let _selectedTime, _selectedDate, _createdatDateTime;

    const isMobileJob = job.deviceid && isVDVType(job.deviceid);

    if (preferences && preferences.pager && preferences.pager.search) {
      let time = preferences.pager.search.find(
        x => x.field === "result_testtime"
      );
      if (time && time.searchvalue !== "") {
        _selectedTime = moment(time.searchvalue, ["HH:mm"]);
        _selectedTime = moment.utc(_selectedTime._i, _selectedTime._f).local();
      } else {
        _selectedTime = selectedTime;
      }

      let date = preferences.pager.search.find(
        x => x.field === "result_testdate"
      );
      if (date && date.searchvalue !== "") {
        let _date = moment(date.searchvalue, ["YYYY-MM-DD"]);
        _selectedDate = _date._d;
      } else {
        _selectedDate = selectedDate;
      }

      let createddatetime = preferences.pager.search.find(
        x => x.field === "result_createdat"
      );
      if (createddatetime && createddatetime.searchvalue !== "") {
        _createdatDateTime = moment(createddatetime.searchvalue, [
          "YYYY-MM-DD HH:mm"
        ]);
        _createdatDateTime = moment
          .utc(_createdatDateTime._i, _createdatDateTime._f)
          .local();
        _createdatDateTime = _createdatDateTime._d;
      } else {
        _createdatDateTime = createdatDateTime;
      }
    }
    if (tests && tests.columns) {
      let col = tests.columns.find(x => x.field !== "name");
      columns.push({
        id: "name",
        accessor: d => d.name,
        display: col ? col.display : true,
        show: true,
        filterable: filterable,
        Header: translate("tests_name"),
        minWidth: 200,
        Cell: o => {
          return (
            <React.Fragment>
              <TestsRowLink
                title={o.row.name}
                key={o.row.detail}
                link={`/results/${job.id}/${o.row.id}`}
              />
            </React.Fragment>
          );
        }
      });
      columns.push({
        id: "attachmentexists",
        display: false,
        show: true,
        filterable: false,
        Header: "",
        width: 25,
        resizable: false,
        Cell: o => {
          return (
            <React.Fragment>
              {o.original.attachmentexists && (
                <Button
                  mini
                  onClick={e => this.showAttachments(e, job.id, o.original.id)}
                  id={job.id}
                  className={classes.attachment}
                >
                  <Icon>attach_file</Icon>
                </Button>
              )}
            </React.Fragment>
          );
        }
      });

      if (job.effectiveSmartFlagProfileId && smartFlagChecksDone && isCometType(job.deviceid) && this.props.appSettingReducer?.activeFeatures?.some(f => f.featureName === 'smart_flag')) {
        // Derive status from the current check-job response so ignored tests stay blank
        // until the refreshed test list catches up with persisted SmartFlagStatus values.
        const checks = smartFlagChecks || [];
        const evaluatedTestIds = new Set(smartFlagEvaluatedTestIds || []);
        const failedTestIds = new Set(checks.map(c => c.testId));

        columns.push({
          id: "smartflagstatus",
          accessor: d => {
            if (failedTestIds.has(d.id)) {
              return "Fail";
            }

            if (evaluatedTestIds.has(d.id)) {
              return "Pass";
            }

            return null;
          },
          display: false,
          show: true,
          filterable: false,
          Header: translate("tests_smartflagstatus"),
          width: 35,
          Cell: o => {
            if (o.row.smartflagstatus === "Pass") {
              return (
                <React.Fragment>
                  <Icon className={classes.passState}>flag</Icon>
                </React.Fragment>
              );
            } else if (o.row.smartflagstatus === "Fail") {
              return (
                <React.Fragment>
                  <Icon className={classes.failFlag}
                        onClick={() => showSmartFlags(o.row.id)}>flag</Icon>
                </React.Fragment>
              );
            } else {
              return null;
            }
          }
        });
      }

      col = tests.columns.find(x => x.field !== "result_teststatus");
      columns.push({
        id: "result_teststatus",
        accessor: d => d.result_teststatus,
        display: col ? col.display : true,
        filterable: false,
        show: true,
        Header: "⇅", //translate('result_teststatus'),
        width: 35,
        resizable: false,
        Cell: o => {
          if (o.row.result_teststatus === "Pass") {
            return (
              <React.Fragment>
                <Icon className={classes.passState}>check_circle</Icon>
              </React.Fragment>
            );
          } else if (o.row.result_teststatus === "Fail") {
            return (
              <React.Fragment>
                <Icon className={classes.failState}>cancel</Icon>
              </React.Fragment>
            );
          } else if (o.row.result_teststatus === "MarginalPass") {
            return (
              <React.Fragment>
                <Badge badgeContent={"!"} className={classes.passStateBadge}>
                  <Icon className={classes.passState}>check_circle</Icon>
                </Badge>
              </React.Fragment>
            );
          } else if (o.row.result_teststatus === "MarginalFail") {
            return (
              <React.Fragment>
                <Badge badgeContent={"!"} className={classes.failStateBadge}>
                  <Icon className={classes.failState}>cancel</Icon>
                </Badge>
              </React.Fragment>
            );
          } else if (o.row.result_teststatus === "Info") {
            return (
              <React.Fragment>
                <Icon className={classes.passState}>info</Icon>
              </React.Fragment>
            );
          } else {
            return null;
          }
        }
      });
      col = tests.columns.find(x => x.field !== "result_testdate");
      columns.push({
        id: "result_testdate",
        accessor: d => d.result_testdate,
        display: col ? col.display : true,
        show: true,
        filterable: filterable,
        Header: translate("result_testdate") + "/" + translate("result_testtime"),
        Cell: o => {
          return o.row.result_testdate
            ? jobDateTimeWithSecondsFormatter(o.row.result_testdate)
            : "";
        },
        width: 175,
        Filter: ({ filter, onChange }) => {
          return (
            <React.Fragment>
              <MuiPickersUtilsProvider utils={MomentUtils} moment={moment}>
                <div className="picker">
                  <DatePicker
                    value={_selectedDate || null}
                    onChange={event => {
                      this.setState(
                        {
                          selectedDate: event ? event._d : null
                        },
                        () => {
                          if (!event) {
                            onChange("");
                            return "";
                          }
                          let date = getISODateString(event._d);
                          onChange(date);
                          return date;
                        }
                      );
                    }}
                    disableFuture={true}
                    clearable
                    format="DD/MM/YYYY"
                  />
                </div>
              </MuiPickersUtilsProvider>
            </React.Fragment>
          );
        }
      });
      col = tests.columns.find(x => x.field !== "result_testtime");
      columns.push({
        id: "result_testtime",
        accessor: d => d.result_testtime,
        display: col ? col.display : true,
        show: true,
        filterable: false,
        Header: translate("result_testtime"),
        Cell: o => {
          let time = "";
          if (o.row.result_testtime) {
            const _date = o.row.mobiletest_mode
              ? moment.utc(o.row.result_testtime, ["HH:mm"]) // Mobile Tests always use UTC
              : moment(o.row.result_testtime, ["HH:mm"]);
            time = _date ? timeFormatter(_date) : "";
          }
          return time ? time : o.row.result_testtime;
        },
        Filter: ({ filter, onChange }) => {
          return (
            <React.Fragment>
              <MuiPickersUtilsProvider utils={MomentUtils} moment={moment}>
                <div className="picker">
                  <TimePicker
                    clearable
                    ampm={false}
                    // keyboard
                    value={_selectedTime}
                    onChange={event => {
                      this.setState(
                        {
                          selectedTime: event ? event._d : null
                        },
                        () => {
                          if (!event) {
                            onChange("");
                            return "";
                          }
                          let time = getISOTimeString(event._d);
                          onChange(time);
                        }
                      );
                    }}
                  />
                </div>
              </MuiPickersUtilsProvider>
            </React.Fragment>
          );
        }
      });

      col = tests.columns.find(x => x.field !== "result_createdat");
      columns.push({
        id: "result_createdat",
        accessor: d => d.result_createdat,
        display: col ? col.display : true,
        show: false,
        filterable: filterable,
        Header: translate("result_createdat"),
        Cell: o => {
          let time = "";
          if (o.row.result_createdat) {
            time = moment(o.row.result_createdat, ["YYYY-MM-DD HH:mm"]);
            time = dateTimeFormatter(time.toString());
          }

          return o.row.result_createdat ? time : "";
        },
        Filter: ({ filter, onChange }) => {
          return (
            <React.Fragment>
              <MuiPickersUtilsProvider utils={MomentUtils} moment={moment}>
                <div className="picker">
                  <DatePicker
                    disableFuture={true}
                    clearable
                    ampm={false}
                    format="DD/MM/YYYY"
                    value={_createdatDateTime || null}
                    onChange={event => {
                      this.setState(
                        {
                          createdatDateTime: event ? event._d : null
                        },
                        () => {
                          if (!event) {
                            onChange("");
                            return "";
                          }
                          let time = getISODateString(event._d);
                          onChange(time);
                        }
                      );
                    }}
                  />
                </div>
              </MuiPickersUtilsProvider>
            </React.Fragment>
          );
        }
      });

      let _tests = tests.columns
        ? tests.columns.filter(x => x.field !== "name")
        : [];
        _tests = _tests.filter(x => x.field != "rowMove");
      _tests = _tests.filter(x => x.field !== "result_teststatus");
      _tests = _tests.filter(x => x.field !== "result_testdate");
      _tests = _tests.filter(x => x.field !== "result_testtime");
      _tests = _tests.filter(x => x.field !== "result_suspicious");
      _tests = _tests.filter(x => x.field !== "result_createdat");
      _tests = _tests.filter(x => x.field !== "result_cdnextworst");
      _tests = _tests.filter(x => x.field !== "result_cdnextmargin");
      _tests = _tests.filter(x => x.field !== "result_cmrlworst");
      _tests = _tests.filter(x => x.field !== "result_cmrlmargin");
      let keys = [1, 2, 3, 4, 5, 6];
      keys.map(k => {
        _tests = _tests.filter(x => x.field !== `level${k}value`);
        _tests = _tests.filter(x => x.field !== `level${k}key`);
        return k;
      });
      _tests = _tests.filter(x => x.field !== "result_suspicious");

      _tests = _tests.sort((x, y) => {
        if (x.order < y.order) return -1;
        if (x.order > y.order) return 1;
        return 0;
      });

      if (!isMobileJob) {
        _tests = _tests.filter(x => !x.field.startsWith("mobiletest_"));
      }

      let _serialNumberTests = _tests.filter(x => x.field == "result_neserialnumber");
      let serialNumberCol = (_serialNumberTests && (_serialNumberTests.length > 0)) ? _serialNumberTests[0] : null;
      _tests = _tests.filter(x => x.field !== "result_neserialnumber");

      _tests.forEach((column, index) => {
        if (
          [
            "result_headroom",
            "result_nextmargin",
            "result_returnlossmargin",
            "result_insertionlossmargin",
            "result_dcresistance",
            "result_propagationdelay",
            "result_delayskew",
            "result_acrnmargin",
            "result_acrfmargin",
            "result_psnextmargin",
            "result_psacrnmargin",
            "result_psacrfmargin",
            "result_nextworst",
            "result_returnlossworst",
            "result_insertionlossworst",
            "result_acrnworst",
            "result_acrfworst",
            "result_psnextworst",
            "result_psacrnworst",
            "result_psacrfworst",
            "result_resunbalworstintrapair",
            "result_resunbalworstp2p",
            "result_eltctlworst",
            "result_eltctlmargin",
            "result_tclmargin",
            "result_tclworst"
          ].includes(column.field)
        ) {
          columns.push({
            id: column.field,
            Header: translate(column.field),
            accessor: d => d[column.field],
            show: defaultColumns.includes(column.field),
            display: column.display,
            group: column.group,
            filterable: column.cansearch && filterable,
            Filter: ({ filter, onChange }) => {
              let value = filter ? filter.value : "";
              return (
                <React.Fragment>
                  <TextField
                    value={value}
                    onChange={e => {
                      let val = e.target.value;
                      onChange(val);
                    }}
                  />
                </React.Fragment>
              );
            },
            Cell: o => {
              let val = "";
              if (o) {
                val = o.value;
                return getFormattedNumber(val);
              }
            }
          });
        } else {
          columns.push({
            id: column.field,
            Header: translate(column.field),
            accessor: d => d[column.field],
            show: defaultColumns.includes(column.field),
            display: column.display,
            group: column.group,
            filterable: column.cansearch && filterable
          });
          if ((column.field == "result_tester") && (serialNumberCol != null)) {
            columns.push({
              id: serialNumberCol.field,
              Header: translate(serialNumberCol.field),
              accessor: d => d[serialNumberCol.field],
              show: defaultColumns.includes(serialNumberCol.field),
              display: serialNumberCol.display,
              group: serialNumberCol.group,
              filterable: serialNumberCol.cansearch && filterable
            });
          }
        }
      });
      col = tests.columns.find(x => x.field === "result_suspicious");
      columns.push({
        id: "result_suspicious",
        accessor: d => d.result_suspicious,
        display: col ? col.display : true,
        filterable: filterable,
        show: false,
        Header: translate("result_suspicious"),
        Cell: o => {
          if (o.row.result_suspicious) {
            return (
              <React.Fragment>
                <Icon>flag</Icon>
              </React.Fragment>
            );
          }
        }
      });
    }

    let aggregateCols = columns.filter(x => x.group).map(x => x["id"]);
    aggregateCols = [
      "level2value",
      "level3value",
      "level4value",
      "level5value",
      "level6value",
      "level2key",
      "level3key",
      "level4key",
      "level5key",
      "level6key"
    ];

    let lengthCol = columns.find(x => x.id === "result_length");
    let lengthColIdx = columns.findIndex(x => x.id === "result_length");
    lengthCol = {
      ...lengthCol,
      Header:
        lengthMeasurementUnit === "feet"
          ? translate("result_length_f")
          : translate("result_length_m"),
      Filter: ({ filter, onChange }) => {
        let value = filter ? filter.value : "";
        return (
          <React.Fragment>
            <TextField
              value={value}
              onChange={e => {
                let val = e.target.value;
                onChange(val);
              }}
            />
          </React.Fragment>
        );
      },
      Cell: o => {
        let val = null;
        if (o) {
          val = o.value;
        }
        if (val == null || val == undefined) {
          return "-";
        }
        if (lengthMeasurementUnit === "feet") {
          return (isMobileJob) ? vdvMetersToFeet(val) : metersToFeet(val);
        }
        return (isMobileJob) ? getFormattedNumberWithPrecision(val, 1) : getFormattedNumber(val);
      }
    };

    if (preferences && preferences.columns) {
      preferences.columns.map(x => {
        columns.find(y => {
          if (x.id === y.id) {
            y.show = x.show;
            return true;
          }
          return false;
        });
        return x;
      });
    }
    columns[lengthColIdx] = lengthCol;

    if (isMobileJob) { // in VDV II Plus, instead of nvp, it's pFm value
      let nvpCol = columns.find(x => x.id === "nvp");
      let nvpColIdx = columns.findIndex(x => x.id === "nvp");
      nvpCol = {
        ...nvpCol,
        Header:
          lengthMeasurementUnit === "feet"
            ? translate("nvp_or_pFft") : translate("nvp_or_pFm"),
        Filter: ({ filter, onChange }) => {
          let value = filter ? filter.value : "";
          return (
            <React.Fragment>
              <TextField
                value={value}
                onChange={e => {
                  let val = e.target.value;
                  onChange(val);
                }}
              />
            </React.Fragment>
          );
        },
        Cell: o => {
          let val = "";
          let deviceType = job.deviceid;
          if (o) {
            val = o.value;
            deviceType = o.row.mobiletest_systemdevicetype;
          }
          if (val == null || val == "") {
            return "-";
          }
          if (deviceType != "vdviiplus" && deviceType != "VDV II Plus") {
            return val + "%";
          }
          if (lengthMeasurementUnit === "feet") {
            let pFperFeet = vdvPicofaradsUnitConversion(val);
            return (pFperFeet == null) ? "" :  pFperFeet + translate("pF_ft");
          }
          return val + translate("pF_m");
        }
      };

      if (preferences && preferences.columns) {
        preferences.columns.map(x => {
          columns.find(y => {
            if (x.id === y.id) {
              y.show = x.show;
              return true;
            }
            return false;
          });
          return x;
        });
      }
      columns[nvpColIdx] = nvpCol;
    }

    let newColumns = columns.filter(x => x.id !== "result_standard" && x.id !== "result_cablename" && x.id !== "result_testtime");
    this.setState({
      columns: newColumns,
      aggregateCols
    });
  }

  selectedRows = (rows, prevTests) => {
    let { selectedTests } = this.state;
    const { tests, pager } = this.props;
    if (prevTests.length > 0) {
      selectedTests = prevTests;
    } else {
      selectedTests = [];
    }

    Object.keys(rows).map(key => {
      if (rows[key]) {
        selectedTests.push(tests.data.find(x => x.id === parseInt(key, 10)));
      } else {
        selectedTests.forEach((element, idx) => {
          if (element && element.id.toString() === key) {
            selectedTests.splice(idx, 1);
          }
        });
      }
      return key;
    });
    selectedTests = selectedTests.filter(i => i !== undefined);
    selectedTests = this.getUnique(selectedTests, "id");
    this.sortSelection(pager.order, selectedTests);
    this.setState({
      selectedTests,
      selectAll:
        tests.data.length === tests.data.filter(e => rows[e.id]).length,
      selected: rows,
      testSelected: rows
    });
  };

  getUnique = (arr, comp) => {
    const unique = arr
      .map(e => e[comp])
      .map((e, i, final) => final.indexOf(e) === i && i)
      .filter(e => arr[e])
      .map(e => arr[e]);

    return unique;
  };

  onSortedChange(newSorted, column, shiftKey) {
    let { selectedTests } = this.state;
    this.sortSelection(
      {
        field: newSorted.field,
        sorttype: newSorted.desc ? "desc" : "asc"
      },
      selectedTests
    );
  }

  sortSelection(sort, selectedTests) {
    const { setSelectedTests } = this.props;

    if (Object.keys(sort).length) {
      selectedTests = selectedTests.sort((x, y) => {
        return x[sort.field] !== y[sort.field]
          ? x[sort.field] < y[sort.field]
            ? -1
            : 1
          : 0;
      });
      if (sort.sorttype === "desc") {
        selectedTests = selectedTests.reverse();
      }
    } else {
      selectedTests = selectedTests.sort((x, y) => {
        return x.name !== y.name ? (x.name < y.name ? -1 : 1) : 0;
      });
    }
    setSelectedTests(selectedTests.length ? selectedTests : null);
  }

  toggle() {
    this.setState({
      contextMenu: !this.state.contextMenu
    });
  }

  toggleFilters = () => {
    if (this.state.filterable) {
      {
        /* this.props.resetSearchFilter() */
      }
    }
    this.setState(
      {
        filterable: !this.state.filterable
      },
      () => {
        const { pager, job, smartFlagChecksDone, smartFlagChecks, smartFlagEvaluatedTestIds } = this.props;
        const { defaultColumns } = pager;
        const { tests } = this.state;
        this.setColumns(tests, defaultColumns, job, null, smartFlagChecksDone, smartFlagChecks, smartFlagEvaluatedTestIds);
      }
    );
  };

  applyPreset(presetColumns) {
    const { selectColumnPreset } = this.props;

    selectColumnPreset(presetColumns);
  }

  toggleColumns(column) {
    const {
      savePreferences,
      pager,
      preferencesSaved,
      preferences
    } = this.props;
    let columns =
      preferences && preferences.columns
        ? [...preferences.columns]
        : [...this.state.columns];
    pager.defaultColumns = [];
    columns.forEach(c => {
      if (c.id === column.id) {
        c.show = column.show;
      }
      if (c.show) {
        pager.defaultColumns.push(c.id);
      }
    });
    this.setState({
      columns: columns
    });

    if (savePreferences && preferencesSaved) {
      savePreferences(pager, columns, preferencesSaved, true);
    }
  }
}

const mapStateToProps = (state) => ({
  nodeSelectedIds: state.treeviewReducer.nodeSelectedIds,
  modifiedJobId: state.jobReducer.modifiedJobId,
  fileUploadSettings: state.appSettingReducer.fileUploadSettings,
  smartFlagChecksDone: state.smartFlagReducer.smartFlagChecksDone,
  smartFlagChecks: state.smartFlagReducer.smartFlagChecks,
  smartFlagEvaluatedTestIds: state.smartFlagReducer.smartFlagEvaluatedTestIds,
  ...state
});

const mapDispatchToProps = (dispatch, props) => ({
  resetJobTreeview: (props) => {
    dispatch(resetJobTreeview());
  },
});

export default
connect(mapStateToProps, mapDispatchToProps)
(withRouter(withStyles(styles)(Job)));
